// Application configuration
export const API_BASE_URL =
  import.meta.env.VITE_API_URL || 'https://carleads-api-staging.carleads.workers.dev';

export const APP_NAME = 'CarLeads';
export const APP_DESCRIPTION = 'AI-Powered Automotive Lead Management Platform';

export const TOKEN_STORAGE_KEY = 'carleads_auth_token';

export const QUERY_CONFIG = {
  staleTime: 30000, // 30 seconds
  cacheTime: 300000, // 5 minutes
  refetchOnWindowFocus: false,
  retry: 1,
};
